import { useEffect, useState } from 'react';
import axios from 'axios';
import { Scale, FileText, BookOpen, Landmark, ChevronRight } from 'lucide-react';
import { DEFAULT_PROJECT_ID } from '@/lib/navTree';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/rera-complaints`;

// Coverage, not impact: what FBC has indexed for TEN BKC, counted live, each linked to its records.
export const EvidenceStrip = ({ onOpen }) => {
  const [e, setE] = useState(null);
  useEffect(() => { axios.get(`${API}/${DEFAULT_PROJECT_ID}/evidence`).then((r) => setE(r.data)).catch(() => {}); }, []);
  if (!e) return null;
  const items = [
    { n: e.complaints, label: 'MahaRERA complaints indexed', icon: Scale, to: 'project-litigation' },
    { n: e.orders_read, label: e.detailed ? `orders read (${e.detailed} in detail)` : 'MahaRERA orders read', icon: BookOpen, to: 'project-litigation' },
    { n: e.rera_documents, label: 'official MahaRERA documents mirrored', icon: FileText, to: 'project-archive' },
    { n: e.corpus_documents, label: `corpus documents · ${e.corpus_events} case events tracked`, icon: Landmark, to: 'corpus-warroom' },
  ];
  return (
    <section className="py-8" data-testid="home-evidence-strip">
      <div className="container mx-auto px-4">
        <p className="text-[11px] uppercase tracking-wider text-muted-foreground mb-2">TEN BKC on FBC · counted live from the records</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {items.map((it) => (
            <button key={it.label} type="button" onClick={() => onOpen(it.to)} data-testid={`evidence-${it.to}-${it.n}`}
              className="text-left rounded-lg border bg-card p-3 hover:border-primary/40 transition-colors group">
              <div className="flex items-center gap-2">
                <it.icon className="h-4 w-4 text-primary" />
                <span className="text-2xl font-semibold tabular-nums" style={{ fontFamily: 'Playfair Display, serif' }}>{it.n}</span>
                <ChevronRight className="h-4 w-4 ml-auto text-muted-foreground group-hover:translate-x-0.5 transition-transform" />
              </div>
              <p className="text-xs text-muted-foreground mt-1">{it.label}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
